<template>
    <div :id="`note-${note.id}`">
        <router-link
            :to="'/admin/notes/' + note.id + '/update'"
            class="w-full bg-white border-b px-3 py-2 cursor-pointer block"
            v-if="$route.name !== 'AdminNotesNoteUpdate'"
        >Edit
        </router-link>

        <button
            class="w-full bg-white border-b px-3 py-2 cursor-pointer red text-left"
            v-on:click.prevent="deleteNote"
        >
            Delete
        </button>

        <vis-dropdown
            :note="note"
            @toggleShow="showOptions = !showOptions"
            title="Change the visibility of your note."
        ></vis-dropdown>

        <a
            :href="`/u/${user.username}/${note.id}/${note.slug}`"
            class="w-full bg-white border-b px-3 py-2 cursor-pointer block"
            v-if="user"
            v-on:click.prevent="viewNote"
        >
            View
        </a>

        <button
            :class="{ 'text-red-500': note.favorite }"
            class="w-full bg-white  border-b px-3 py-2 cursor-pointer red text-left text-gray-500"
            v-on:click.prevent="favoriteNote"
        >
            <Zondicon class="w-4 h-4 fill-current" icon="StarFull" />
        </button>

        <button
            class="w-full bg-white border-b px-3 py-2 cursor-pointer red text-left"
            v-if="note.is_encrypted"
            v-on:click.prevent="decryptNote"
        >
            Decrypt
        </button>
        <button
            class="w-full bg-white border-b px-3 py-2 cursor-pointer red text-left"
            v-else
            v-on:click.prevent="encryptNote"
        >
            Encrypt
        </button>
        <div
            class="w-full bg-white border-b px-3 py-2 cursor-pointer red text-left"
            v-on:click.prevent="syncNote"
        >
            Sync
        </div>
    </div>
</template>

<script>
    import VisDropdown from "./VisDropdown.vue";
    import { API_URL } from "../../env.js";
    import qs from "query-string";


    export default {
        props: ["note", "closeMenu"],
        components: {
            VisDropdown,
        },
        mounted() {
            // If the user clicks outside of the recent-notes, close the suggestions
            let searchBoxArea = document.getElementById(`note-${this.note.id}`);
            searchBoxArea.addEventListener("click", this.handleInsideClick);
            document.body.addEventListener("click", this.handleOutsideClick);
        },
        beforeDestroy() {
            document.body.removeEventListener("click", this.handleOutsideClick);
        },
        methods: {
            async syncNote() {
                const res = await this.$store.dispatch("aSyncNote", this.note.id);
                this.closeMenu();
            },
            viewNote() {
                this.$router.push({
                    path: `/u/${this.user.username}/${this.note.book.slug}/${this.note.slug}`
                });
                this.closeMenu();
            },
            handleClick() {},
            handleOutsideClick() {
                this.closeMenu();
            },
            handleInsideClick(e) {
                e.stopPropagation(); // this will stop propagation of this event to upper level
            },
            /**
             * User deletes note.
             * Check buffer before deleting note.
             * Buffer of next page exists.
             *     Delete the note.
             *     Move one note from buffer to current list.
             * Buffer does not exist.
             *     Get the next page of results and add to buffer.
             *     Delete the note.
             *     Move one note from buffer to current list.
             * @returns {Promise<void>}
             */
            async deleteNote() {

                // Check buffer before deleting note.
                // Get some buffer notes if none exist or if the user has changed the URL (paginated, filtered, searched, etc.)
                const queryString = qs.stringify(this.$route.query);
                const shouldGetNotes = queryString !== this.notesFetchKey;
                if (this.bufferNotes.length === 0 || shouldGetNotes) {
                    let search = Object.assign({}, this.$route.query);
                    search.page = search.page ? search.page + 1 : 2;
                    let newSearch = qs.stringify(search);
                    console.log("getting buffer notes", this.bufferNotes, this.notesFetchKey, queryString);
                    const uri = `${API_URL}/admin/notes?${newSearch}`;
                    await this.$store.dispatch("aGetBufferNotes", {
                        uri,
                        notesFetchKey: queryString
                    });
                }

                // Delete the note.
                await this.$store.dispatch("aDeleteNote", this.note.id);

                // Move one note from buffer to current list.
                this.$store.dispatch("aMoveBufferNotes", 1);

                // delete the note and then silently get the note that would be skipped if the page was paginated
                // const uri = `${API_URL}${this.$route.fullPath}`;
                // this.$store.dispatch("aGetNotesAdmin", {uri, showLoading: false});
                // this.$store.dispatch("aGetLastNote", { uri });
                // this.$confirm("Are you sure you want to delete this?").then(choice => {
                //   if (choice === true) {
                //     this.$store.dispatch("DELETE_NOTE", this.note.id);
                //   }
                // });
            },
            favoriteNote() {
                let noteCopy = Object.assign({}, this.note);
                noteCopy.favorite = !noteCopy.favorite;
                this.$store.dispatch("aFavoriteNote", noteCopy);
                this.closeMenu();
            },

            // to encrypt a note, set note.is_encrypted to true and move note.content to note.encrypted
            // then, update the note as normal
            async encryptNote() {
                this.$loading(true);
                let noteCopy = Object.assign({}, this.note);
                noteCopy.is_encrypted = true;
                noteCopy.encrypted = noteCopy.content;
                noteCopy.content = null;
                noteCopy.encrypter_id = this.user.encrypter.id;
                try {
                    const res = await this.$store.dispatch("aUpdateNotes", {
                        notes: [noteCopy]
                    });
                } catch (e) {
                    this.$loading(false);
                }
                // await this.$store.dispatch('aSetNote', noteCopy);
                this.$loading(false);
                this.closeMenu();
            },
            // decrypting is even more straightforward.
            async decryptNote() {
                console.log("note", this.note);
                this.$loading(true);
                let noteCopy = Object.assign({}, this.note);
                noteCopy.content = noteCopy.encrypted;
                noteCopy.encrypted = null;
                noteCopy.is_encrypted = 0;
                noteCopy.encrypter_id = null;
                console.log("noteCopy", noteCopy);
                try {
                    const res = await this.$store.dispatch("aUpdateNotes", {
                        notes: [noteCopy]
                    });
                } catch (e) {
                    this.$loading(false);
                }
                // await this.$store.dispatch('aSetNote', noteCopy);
                this.$loading(false);
                this.closeMenu();
            }
        },

        computed: {
            isNoteOrBook() {
                return this.$route.query.book || this.$route.params.note;
            },
            user() {
                return this.$store.state.notes.user;
            },
            bufferNotes() {
                return this.$store.state.notes.bufferNotes;
            },
            notesFetchKey() {
                return this.$store.state.notes.notesFetchKey;
            }
        }
    };
</script>
